import { SimpleGrid } from '@mantine/core';
import { useState } from 'react';
import YoutubeCard, { IClip } from '../YoutubeCard/YoutubeCard';
import YoutubePlayer from '../YoutubePlayer/YoutubePlayer';
import { Wrapper } from './YoutubeGallery.style';

export type YoutubeGalleryProps = {
  clips: IClip[];
};

export function YoutubeGallery(props: YoutubeGalleryProps) {
  const { clips } = props;
  const [currentClip, setCurrentClip] = useState<IClip>(clips[0]);

  function onClick(value: IClip) {
    setCurrentClip(value);
  }

  return (
    <Wrapper className='YoutubeGallery-wrapper' data-testid='YoutubeGallery-wrapper'>
      <YoutubePlayer clip={currentClip} />
      <SimpleGrid cols={4} spacing='lg' mt='md'>
        {clips.map((clip) => (
          <YoutubeCard key={clip.id} clip={clip} onClick={() => onClick(clip)} />
        ))}
      </SimpleGrid>
    </Wrapper>
  );
}

export default YoutubeGallery;
